import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8e34d86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "img-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "container-fluid py-3" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-center text-primary mb-4 mt-2" }, " Recent Health Priority Needs ")
], -1))
const _hoisted_4 = { class: "container-lg container-fluid px-lg-5 px-3" }
const _hoisted_5 = {
  key: 0,
  v: ""
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 1,
  class: "no_data_mini"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "No Health Priority Needs", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "datar_container"
}
const _hoisted_11 = {
  key: 0,
  class: "row"
}
const _hoisted_12 = {
  key: 1,
  class: "message"
}
const _hoisted_13 = { class: "footer_section" }
const _hoisted_14 = { class: "details" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "d-none d-md-block" }, " Are you an employee of the Ministry of Health? Have you identified a health need that requires an innovative solution? ", -1))
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "container-lg container-fluid mt-5 mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelcomeScreen = _resolveComponent("WelcomeScreen")!
  const _component_WelcomeImageLoader = _resolveComponent("WelcomeImageLoader")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_List = _resolveComponent("List")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("section", _hoisted_2, [
      _createVNode(_component_WelcomeScreen, {
        onLoaded: _ctx.onImgLoad,
        welcomeDetail: _ctx.Welcome
      }, null, 8, ["onLoaded", "welcomeDetail"])
    ], 512), [
      [_vShow, _ctx.isLoaded]
    ]),
    _withDirectives(_createVNode(_component_WelcomeImageLoader, null, null, 512), [
      [_vShow, !_ctx.isLoaded]
    ]),
    _hoisted_3,
    _createElementVNode("section", _hoisted_4, [
      (_ctx.FourDatas.length === 0 && _ctx.loading === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                return _createElementVNode("div", {
                  class: "col-lg-3 col-md-4 col-6",
                  key: i
                }, [
                  _createVNode(_component_Skeleton, {
                    width: "100%",
                    height: "10rem",
                    class: "mb-3"
                  })
                ])
              }), 64))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.FourDatas.length === 0 && _ctx.loading === false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        : _createCommentVNode("", true),
      (_ctx.FourDatas.length > 0)
        ? (_openBlock(), _createElementBlock("main", _hoisted_10, [
            (_ctx.Message === '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FourDatas, (item, i) => {
                    return (_openBlock(), _createBlock(_component_Card, {
                      key: i,
                      body: item,
                      card: _ctx.cardStyle,
                      route: `/submit-proposal/call-for-proposal/${item.id}/?id=${item.id}`
                    }, null, 8, ["body", "card", "route"]))
                  }), 128))
                ]))
              : (_ctx.Message !== '')
                ? (_openBlock(), _createElementBlock("h5", _hoisted_12, _toDisplayString(_ctx.Message), 1))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_component_BaseButton, {
          customStyle: _ctx.buttonStyle,
          onClick: _ctx.gotoForm
        }, {
          default: _withCtx(() => [
            _createTextVNode("SUBMIT A HEALTH PRIORITY NEED")
          ]),
          _: 1
        }, 8, ["customStyle", "onClick"])
      ]),
      _createElementVNode("img", {
        src: require('@/assets/png/asset3.jpg'),
        alt: "Health needs",
        class: "img-fluid"
      }, null, 8, _hoisted_16)
    ]),
    _createElementVNode("section", _hoisted_17, [
      _createVNode(_component_List)
    ])
  ]))
}